import { Typography } from '@mui/material'

const PageHeader = ({ title, children, padding = 'px-4 pb-0' }) => {
  return (
    <div
      className={`flex items-center justify-between border-b border-[var(--border-strong)] ${padding}`}
    >
      <Typography
        className="text-[var(--forbrand-primary)] mb-0 !font-[600]"
        variant="h1"
        sx={{ fontSize: '20px' }}
      >
        {title}
      </Typography>
      {children}
    </div>
  )
}

export default PageHeader
